import React from "react";
import Chart from "react-apexcharts";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Dashboradscharts from "./Dashboradscharts";
import Dispatchissue from "./Dispatchissue";

export default function Dashboardstatics() {
  const state = {
    stroke: {
      lineCap: "round",
    },
    options: {
      dataLabels: {
        enabled: false,
      },
      legend: {
        fontSize: "16px",
        fontWeight: "700",
        fontFamily: "Poppins",
        position: "right",
        horizontalAlign: "center",

        // labels: {
        //   show: true,
        //   name: "Total Issus",
        //   value: 263,
        // },
      },

      title: {
        text: "125",
        align: "center",
        margin: 10,
        offsetX: -55,
        offsetY: 115,
        floating: false,
        style: {
          fontSize: "24px",
          fontWeight: "bold",
          color: "#000",
        },
      },
      subtitle: {
        text: "Items",
        align: "center",
        margin: 10,
        offsetX: -55,
        offsetY: 145,
        floating: false,
        style: {
          fontSize: "16px",
          fontWeight: "300",
          color: "#000",
        },
      },
      // subtitle: {
      //   text: ,
      //   align: "center",
      //   margin: 10,
      //   offsetX: 0,
      //   offsetY: 105,
      //   floating: false,
      //   style: {
      //     fontSize: "14px",
      //     fontWeight: "bold",
      //     color: "#000",
      //   },
      // },
      labels: ["Damaged", "Faulty", "Missing"],
      colors: ["#FF0000", "#FFFF00", "#00FF00"],

      plotOptions: {
        pie: {
          customScale: 1,
          donut: {
            size: "83%",
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
          },
        },
      },
    },

    series: [45, 35, 20],
  };
  return (
    <div>
      <div class="flex flex-wrap justify-center mt-8">
        <div class="w-full  flex-1 shadow-md shadow-slate-400 bg-white sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl shadow-[0 0 15]">
        <h1 className="text-lg ml-2 text-gray-500 mt-2 font-bold ">
            Inventory Accuracy
          </h1> 
        <div className=" px-9 mt-9">
            <CircularProgressbar
              value={84}
              text={`${84}%`}
              circleRatio={0.75}
              styles={buildStyles({
                rotation: 1 / 2 + 1 / 8,
                strokeLinecap: "butt",
                // trailColor: "#26F32E",
                textColor: "black",
                pathColor: "#26F32E",
                // trailColor: "gold"
              })}
            />
          </div>
          <h1 className="text-lg text-center text-gray-500 mt-2 font-bold ">
            Quality Accuracy
          </h1>
          <p className="text-red-600 text-center pt-2 ">
            <span>
              <span className="inline-block">
                {" "}
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 7L7.70711 6.29289L7 5.58579L6.29289 6.29289L7 7ZM11.2071 9.79289L7.70711 6.29289L6.29289 7.70711L9.79289 11.2071L11.2071 9.79289ZM6.29289 6.29289L2.79289 9.79289L4.20711 11.2071L7.70711 7.70711L6.29289 6.29289Z"
                    fill="#F32626"
                  />
                  <path
                    d="M7 3.5L7.70711 2.79289L7 2.08579L6.29289 2.79289L7 3.5ZM11.2071 6.29289L7.70711 2.79289L6.29289 4.20711L9.79289 7.70711L11.2071 6.29289ZM6.29289 2.79289L2.79289 6.29289L4.20711 7.70711L7.70711 4.20711L6.29289 2.79289Z"
                    fill="#F32626"
                  />
                </svg>
              </span>
              <span className="ml-1 font-medium">45.38%</span>
            </span>
          </p>
          <div className="text-center mb-4  mt-4">
            <div className="">
              <button className="rounded-full w-24 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                {" "}
                February              </button>
            </div>
          </div>
        </div>
        <div class="w-full md:overflow-x-auto sm:overflow-x-auto bg-white  flex-4 sm:w-1/2 md:w-1/3 lg:w-2/3  xl:w-1/6 mb-4 mx-4 shadow-md shadow-slate-400 rounded-xl">
          <div className="flex flex-wrap mt-1 pt-2">
            <div className="float-right ml-auto mr-4 mt-1">
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full w-8 text-blue-900 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3 float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div
            className="tabelcontainer overflow-auto"
            // "w-[calc(100vw_-_12rem)]"
          >
            <div className="flex">
              {" "}
              <h3 className="text-2xl font-bold ml-3 pl-8">
                {" "}
                243,367,383
              </h3>{" "}
              <h3 className="text-xl ml-2"> Items</h3>
            </div>

            <div className="p-20">
              <div class="w-full h-6 bg-cyan-200  rounded-full ">
                <div
                  class="h-6 bg-blue-200 rounded-full "
                  style={{ width: "85%" }}
                ></div>
              </div>
            </div>
            <div className="flex p-16 -mt-28 ml-4">
              <div className=" text-center w-fit align-middle text-gray-400 cursor-pointer pb-2">
                <div className="flex">
                  <div class="w-12 h-6 bg-blue-200 rounded-full "></div>
                  <p className="ml-5"> Targeted Inventory</p>
                </div>
                <p className="font-bold text-lg text-black ml-16">
                  24,496,362 items
                </p>
              </div>
              <div className=" text-center w-fit align-middle ml-6 text-gray-400 cursor-pointer pb-2">
                <div className="flex ml-5">
                  <div class="w-12 h-6 bg-cyan-200 rounded-full "></div>
                  <p className="ml-5"> Real Inventory</p>{" "}
                </div>
                <p className="font-bold text-lg text-black ml-16">654 items</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-8">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-lg flex-1">
          <div className="flex flex-wrap mr-4 pt-2">
            <h3 className="text-xl font-bold ml-6"> Shrinkage</h3>
          </div>
          <div className="flex flex-wrap pb-2">
            <div className="flex-1 flex-wrap ">
              <Chart
                // className="sm:w-32"
                //@ts-ignore
                options={state.options}
                series={state.series}
                type="donut"
                width="380"
              />
            </div>
            <div className="flex-2 md:overflow-x-auto overflow-x-auto  float-right ml-auto mr-4 mt-1">
              <div className="flex p-22 mt-2">
                <div className=" text-center w-fit align-middle  cursor-pointer pb-2">
                  <div className="flex">
                    <p className="ml-5 font-bold  text-red-700"> A Grade</p>
                  </div>
                  <p className=" text-lg text-black ml-4">496,362 items</p>
                </div>
                <div className=" text-center w-fit align-middle ml-1  cursor-pointer pb-2">
                  <div className="flex ml-5">
                    <p className="ml-5 font-bold  text-yellow">
                      {" "}
                      B Grade
                    </p>{" "}
                  </div>
                  <p className=" text-lg text-black ml-4 pl-4">942,654 items</p>
                </div>
                <div className=" text-center w-fit align-middle ml-6  cursor-pointer pb-2">
                  <div className="flex ml-5">
                    <p className="ml-5 font-bold  text-green-500">
                      {" "}
                      C Grade
                    </p>{" "}
                  </div>
                  <p className=" text-lg text-black ml-4 pl-4">654,485 items</p>
                </div>
              </div>
              <div class="relative pt-1 px-12 mt-2">
                <div className="flex text-lg ">
                  <p className="font-bold text-2xl ml-2 mr-3">594 </p> Total
                </div>
                <div class="overflow-hidden h-6 mb-4 text-xs flex rounded-2xl bg-yellow">
                  <div
                    style={{ width: "30%" }}
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                  ></div>
                  <div
                    style={{ width: "45%" }}
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-orange-50"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dashboradscharts />
      <Dispatchissue />
    </div>
  );
}
